import { Controller } from "@hotwired/stimulus"
import PusherManager from "../services/pusher_manager"
import FlashMessage from "../services/flash_message"
import { turboFetch } from "../util/common"

export default class extends Controller {
  static values = {
    speakersChatId: Number,
    viewersChatId: Number,
    liveEventId: Number,
    currentUserId: Number,
    sidebarUrl: String,
    chatsUrl: String,
    meetingRoomUrl: String,
    controlPanelUrl: String
  }

  connect() {
    this.handleChatActiveToggle = this.handleChatActiveToggle.bind(this)
    this.handleChatArchiveToggle = this.handleChatArchiveToggle.bind(this)
    this.handleStatusChanged = this.handleStatusChanged.bind(this)
    this.handleSpeakerRemoved = this.handleSpeakerRemoved.bind(this)
    this.handleVideoReady = this.handleVideoReady.bind(this)

    if (!PusherManager.isInitialized()) {
      PusherManager.initialize()
    }

    if (this.hasSpeakersChatIdValue) {
      PusherManager.subscribeToChatActiveToggle(this.speakersChatIdValue, this.handleChatActiveToggle)
    }

    if (this.hasViewersChatIdValue) {
      PusherManager.subscribeToChatArchiveToggle(this.viewersChatIdValue, this.handleChatArchiveToggle)
    }

    if (this.hasLiveEventIdValue) {
      PusherManager.subscribeToLiveEventStatusChanged(this.liveEventIdValue, this.handleStatusChanged)
      PusherManager.subscribeToLiveEventSpeakerRemoved(this.liveEventIdValue, this.handleSpeakerRemoved)
      PusherManager.subscribeToLiveEventVideoReady(this.liveEventIdValue, this.handleVideoReady)
    }
  }

  disconnect() {
    PusherManager.unsubscribe(this.handleChatActiveToggle)
    PusherManager.unsubscribe(this.handleChatArchiveToggle)
    PusherManager.unsubscribe(this.handleStatusChanged)
    PusherManager.unsubscribe(this.handleSpeakerRemoved)
    PusherManager.unsubscribe(this.handleVideoReady)
  }

  handleChatActiveToggle() {
    this.refreshSidebar()
    this.refreshChats()
  }

  handleChatArchiveToggle() {
    this.refreshSidebar()
    this.refreshChats()
  }

  handleStatusChanged() {
    this.refreshSidebar()
    this.refreshMeetingRoom()
    this.refreshControlPanel()
  }

  handleSpeakerRemoved(data) {
    if (this.isCurrentUserRemoved(data)) {
      this.showFlashAndReloadPage()
      return
    }
  }

  handleVideoReady() {
    new FlashMessage("Recorded video is ready", "notice").show()
    this.refreshSidebar()
    this.refreshMeetingRoom()
  }

  isCurrentUserRemoved(data) {
    return data.removedUserIds?.includes(this.currentUserIdValue)
  }

  showFlashAndReloadPage() {
    const RELOAD_DELAY_MS = 3000

    new FlashMessage("You have been removed from this stream", "alert").show()
    setTimeout(() => window.location.reload(), RELOAD_DELAY_MS)
  }

  refreshSidebar() {
    turboFetch(this.sidebarUrlValue, { method: "GET" })
  }

  refreshChats() {
    turboFetch(this.chatsUrlValue, { method: "GET" })
  }

  refreshMeetingRoom() {
    turboFetch(this.meetingRoomUrlValue, { method: "GET" })
  }

  refreshControlPanel() {
    turboFetch(this.controlPanelUrlValue, { method: "GET" })
  }
}
